import React, { useState, useEffect, useRef } from "react";

const PopupHome = () => {
  const [isPopupHomeVisible, setPopupHomeVisible] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);
  const popupRef = useRef(null);

  useEffect(() => {
    const userId = localStorage.getItem("userId");

    if (!userId) {
      const timer = setTimeout(() => {
        setPopupHomeVisible(true);
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, []);

  const closePopupHome = () => {
    setPopupHomeVisible(false);
  };

  const openCalendlyPopup = () => {
    window.open("https://calendly.com/myprega/1-to-1", "_blank");
  };

  const handlePopupScroll = () => {
    const popup = popupRef.current;

    if (!popup) {
      return;
    }

    const maxScroll = popup.scrollHeight - popup.clientHeight;
    const nextProgress = maxScroll > 0 ? popup.scrollTop / maxScroll : 0;
    setScrollProgress(nextProgress);
  };

  return (
    <>
      {isPopupHomeVisible && (
        <div
          className="popuphome-overlay"
          onClick={closePopupHome}
        >
          <div
            ref={popupRef}
            className="popuphome"
            onScroll={handlePopupScroll}
            onClick={(event) => event.stopPropagation()}
          >
            <div className="popuphome-scroll-indicator" aria-hidden="true">
              <span style={{ transform: `translateY(${scrollProgress * 194}%)` }} />
            </div>
            <button
              onClick={closePopupHome}
              className="popuphome-close"
              aria-label="Close popup"
            >
              &times;
            </button>

            <div className="popuphome-eyebrow">Free Pregnancy Audit</div>

            <h2 className="popuphome-title">
              Find the Hidden gaps in Your Pregnancy Journey That Your
              10-Minute, Rushed Checkup May Have Missed
            </h2>

            <p className="popuphome-lead">
              Rushed gynecologist visits can leave your mind full of unanswered
              questions and doubts. Don&apos;t let your pregnancy to a chance.
            </p>

            <p className="popuphome-body">
              Book a 30-minute, 1-on-1 Pregnancy audit session with a Senior
              Myprega Expert to identify hidden gaps in your pregnancy care.
            </p>

            <div className="popuphome-section-title">
              Here&apos;s exactly what you&apos;ll get in your free 30-minute
              session:
            </div>

            <ul className="popuphome-list">
              <li>
                <span className="popuphome-icon">🔍</span>
                <span>
                  <strong>Identify Potential Risks</strong>: Spot red flags and
                  gaps in your routine care early, so you know what needs your
                  attention.
                </span>
              </li>
              <li>
                <span className="popuphome-icon">🗺️</span>
                <span>
                  <strong>Custom Care Roadmap:</strong> Get a tailored,
                  week-by-week plan based on your individual pregnancy needs.
                </span>
              </li>
              <li>
                <span className="popuphome-icon">🚫</span>
                <span>
                  <strong>Zero Sales, Just Genuine Care</strong>: No pitching,
                  no rushed answers. Just a safe space to ask every question on
                  your mind.
                </span>
              </li>
              <li>
                <span className="popuphome-icon">💖</span>
                <span>
                  <strong>Total Peace of Mind:</strong> Walk away feeling heard,
                  informed, and more confident about the rest of your pregnancy
                  journey.
                </span>
              </li>
            </ul>

            <button
              className="popuphome-cta"
              onClick={openCalendlyPopup}
            >
              Claim My Free 1-on-1 Pregnancy Audit Session Now
            </button>

            <div className="popuphome-note">
              Worth <span className="popuphome-note-price">₹999</span> | Limited Slots Available
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PopupHome;
